import Absolute from "./Absolute";

export const Loading = {
  Absolute,
};
